// src/utils/async/dedupe.ts
/**
* Shares one in-flight run of `task` across concurrent triggers.
*
* - Once it settles, the next trigger starts a fresh run (unlike `coalesce`, no trailing run).
* - The returned promise rejects with whatever `task` throws.
*/
const dedupe = (task) => {
	let inflight = null;
	const runTask = async () => await task();
	return () => {
		inflight ??= runTask().finally(() => {
			inflight = null;
		});
		return inflight;
	};
};
export { dedupe as t };

//# sourceMappingURL=dedupe-Bu0d2i_w.js.map